import { Box } from '@mui/material';
import Logo from './Logo';
// import SubLogo from './SubLogo';

const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
    <Logo
      sx={{
        height: 50,
        width: 'auto',
        maxWidth: '100%'
      }}
    />
    {/* <SubLogo
      sx={{
        height: 50,
        width: 1000
      }}
    /> */}
  </Box>
);

export default SlashScreen;
